import * as Yup from "yup";

Yup.addMethod(Yup.string, "or", function (schemas, msg) {
  return this.test({
    name: "or",
    message: "Please enter valid user ID or email." || msg,
    test: (value) => {
      if (Array.isArray(schemas) && schemas.length > 1) {
        const resee = schemas.map((schema) => schema.isValidSync(value));
        return resee.some((res) => res);
      } else {
        throw new TypeError("Schemas is not correct array schema");
      }
    },
    exclusive: false,
  });
});

export const signInSchema = Yup.object({
  emailAndUserId: Yup.string()
    .or([Yup.string().email(), Yup.string().max(20)])
    .required("please enter either user id or email"),
  password: Yup.string().min(6).required("please enter your password"),
});
export const signInSchemaEI = Yup.object({
  email: Yup.string(),
  user_id: Yup.string().max(20).required("Please enter a user id"),
  password: Yup.string().min(6).required("Please enter your password"),
});
export const signOnlyID = Yup.object({
  user_id: Yup.string(),
  password: Yup.string().min(6).required("Please enter your password"),
});
export const allFour = Yup.object({
  user_id: Yup.string(),
  email: Yup.string().email().required("Please enter a valid email"),
  orgId: Yup.string().max(20).required("Enter a valid orgnization ID"),
  password: Yup.string().min(6).required("Please enter your password"),
});
export const allThree = Yup.object({
  user_id: Yup.string(),
  email: Yup.string().email().required("Please enter a valid email"),

  password: Yup.string().min(6).required("Please enter your password"),
});
export const signInWithOrgId = Yup.object({
  emailAndUserId: Yup.string().or([Yup.string().email(), Yup.string().max(20)]),

  password: Yup.string().min(6).required("please enter your password"),
  orgId: Yup.string().max(20).required("Enter a valid orgnization ID"),
});
export const forgotInSchema = Yup.object({
  emailAndUserId: Yup.string()
    .or([Yup.string().email(), Yup.string().max(20)])
    .required("please enter either user id or email"),
});

export const forgotInWithOrgId = Yup.object({
  emailAndUserId: Yup.string()
    .or([Yup.string().email(), Yup.string().max(20)])
    .required("please enter either user id or email"),
  orgId: Yup.string().max(20).required("Enter a valid orgnization ID"),
});
export const forgotInWithOrgIdAndQues = Yup.object({
  emailAndUserId: Yup.string()
    .or([Yup.string().email(), Yup.string().max(20)])
    .required("Please enter either user id or email"),
  orgId: Yup.string().max(20).required("Enter a valid organization ID"),
  question: Yup.string()
    .oneOf(
      [Yup.ref("givenQuestion")],
      "Selected question should match the given question"
    )
    .max(100)
    .required("Select a security question"),
  givenQuestion: Yup.string().max(100).required("Given question is required"),
  answer: Yup.string()
    .transform((value) => value.toLowerCase())
    .oneOf([Yup.ref("givenAnswer")], "Entered answer is not matching")
    .max(100)
    .required("Enter Your Answer"),
  givenAnswer: Yup.string().max(100).required("Enter Your Answer"),
});
export const signUpSchema = Yup.object({
  name: Yup.string().min(3).required("please enter a valid orgnization name"),
  email: Yup.string().email().required("please enter your email"),
  password: Yup.string().min(6).required("please enter your password"),
});

export const emailSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Email is required"),
});

export const resetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .test("no-spaces", "Spaces are not allowed", (value) => !/\s/.test(value))
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[_\W])[A-Za-z\d_\W]{8,}$/,
      "Password should meet the criteria"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

export const resetPasswordSchema2 = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .test("no-spaces", "Spaces are not allowed", (value) => !/\s/.test(value))
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[_\W])[A-Za-z\d_\W]{8,}$/,
      "Password should meet the criteria"
    ),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),

  oldPassword: Yup.string().required("Old password is required"),
});
